import classNames from 'classnames';
import { FC } from 'react';

type TLikeIconProps = {
  className?: string;
};

const LikeIcon: FC<TLikeIconProps> = ({ className }) => (
  <svg width="20" height="17" viewBox="0 0 20 17" xmlns="http://www.w3.org/2000/svg">
    <path
      className={classNames('fill-none', className)}
      d="M17.3671 2.26653C16.9415 1.8407 16.4361 1.5029 15.8799 1.27243C15.3237 1.04196 14.7275 0.92334 14.1254 0.92334C13.5234 0.92334 12.9272 1.04196 12.371 1.27243C11.8147 1.5029 11.3094 1.8407 10.8838 2.26653L10.0004 3.14986L9.11709 2.26653C8.25735 1.40678 7.09129 0.923785 5.87542 0.923785C4.65956 0.923785 3.4935 1.40678 2.63376 2.26653C1.77401 3.12627 1.29102 4.29233 1.29102 5.50819C1.29102 6.72405 1.77401 7.89012 2.63376 8.74986L3.51709 9.63319L10.0004 16.1165L16.4838 9.63319L17.3671 8.74986C17.7929 8.32423 18.1307 7.81887 18.3612 7.26266C18.5917 6.70644 18.7103 6.11027 18.7103 5.50819C18.7103 4.90612 18.5917 4.30995 18.3612 3.75373C18.1307 3.19752 17.7929 2.69216 17.3671 2.26653V2.26653Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LikeIcon;
